import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_HUBSPOT_DM_CREATION_CONFIG = defineFcm('hubspot_dm_creation_config')
	.asJson(
		z.object({
			enabled: z.boolean(),
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'petition-service',
		context: 'HubSpot decision makers',
		description:
			'Controls whether petition_service creates net-new decision makers from HubSpot. Creation runs only when enabled is true.',
		template: { enabled: true },
	});
